/**
 * UUID v4 gerador seguro para qualquer contexto.
 *
 * `crypto.randomUUID()` só existe em contextos seguros (HTTPS ou localhost).
 * Quando o app roda em http://<IP-LAN> (não seguro), essa API não existe e
 * `crypto.randomUUID` é `undefined` → "is not a function". Este helper faz
 * fallback para `crypto.getRandomValues` (disponível em QUALQUER contexto)
 * e, por fim, para Math.random — sempre retornando um UUID v4 válido.
 */

export function uuidv4(): string {
  const globalCrypto = typeof crypto !== 'undefined' ? crypto : undefined;

  // Contexto seguro: usa a API nativa.
  if (globalCrypto && typeof globalCrypto.randomUUID === 'function') {
    return globalCrypto.randomUUID();
  }

  // Fallback: gera 16 bytes aleatórios via getRandomValues (ou Math.random).
  const bytes = new Uint8Array(16);
  if (globalCrypto && typeof globalCrypto.getRandomValues === 'function') {
    globalCrypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  // Ajusta para UUID v4 (version 4, variant 10).
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
